export const isEqualAsSet = (a: unknown, b: unknown) => {
	if (Array.isArray(a) && Array.isArray(b)) {
		return new Set(a).size === new Set(b).size && a.every((v) => b.includes(v))
	}
	return undefined
}
